import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

type LabelProps = {
  children: ReactNode;
  /**
   * Couleur selon le fond : `mute` sur clair, `encre` pour un label mis en
   * avant, `clair` sur encre, `ciel` sur encre pour un repère.
   */
  tone?: 'mute' | 'encre' | 'clair' | 'ciel';
  className?: string;
  as?: 'span' | 'p' | 'h4';
};

const TONES = {
  mute: 'text-encre-mute',
  encre: 'text-encre',
  clair: 'text-blanc/70',
  ciel: 'text-ciel',
} as const;

/**
 * Label : capitales espacées, chiffres tabulaires — eyebrows, dates, types,
 * méta. La couleur passe par `tone`, jamais par `className` : `cn()` ne
 * fusionne pas deux couleurs en conflit.
 */
export function Label({ children, tone = 'mute', className, as: Tag = 'span' }: LabelProps) {
  return <Tag className={cn('label m-0 font-normal', TONES[tone], className)}>{children}</Tag>;
}
